import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import FilterCustom from "./Filter"
import ViewSaleDetailModal from "../Modal/DetailModal"
import ViewSimDetailModal from "../Modal/ViewSimDetailModal"

function ListSale({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
  setKeywordExcel,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isSimModalOpen, setIsSimModalOpen] = useState(false)

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setParentFilter(filter)
    setKeywordExcel(keyword)
    try {
      const res = await ReportsService.getListSale({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        console.log("API trả về:", res.success.data)

        const formatted = res.success.data.map((item, index) => ({
          ID: item.ID,
          key: item.ID || index,
          export_code: item.export_code || "",
          customer: item.customer || null, 
          sim_quantity: item.sim_quantity || 0,
          data_quantity: item.data_quantity || 0, 
          approved_export_at: item.approved_export_at || "", 
          create_at: item.create_at || "",
          total_amount: item.total_amount
            ? Number(item.total_amount).toLocaleString()
            : "0", // Tổng tiền
          total_discount: item.total_discount
            ? Number(item.total_discount).toLocaleString()
            : "0", // Tổng tiền sau chiết khấu
          profit: (
            Number(item.total_discount) - Number(item.import_price)
          ).toLocaleString(),
          createby: item.createby || null, // Người tạo (object)
          created_at: item.created_at || "", // Ngày tạo
          approved_person: item.approved_export_by?.fullname || "", // Người duyệt
        }))

        setDataSource(formatted)
        setSummary({
          total_sim: Number(res?.success?.sim?.total_sim || 0).toLocaleString(
            "en-US",
            { maximumFractionDigits: 0 },
          ),
          total_amount: Number(
            res?.success?.sim?.total_amount || 0,
          ).toLocaleString("en-US", { maximumFractionDigits: 0 }),
          total_discount: Number(
            res?.success?.sim?.total_discount || 0,
          ).toLocaleString("en-US", { maximumFractionDigits: 0 }),
          total_profit: Number(
            res?.success?.sim?.total_profit || 0,
          ).toLocaleString("en-US", { maximumFractionDigits: 0 }),
        })

        setPagination({
          ...pagination,
          total: res.success.total,
        })
      }
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  useEffect(() => {
    setPagination({
      ...pagination,
      current: 1,
    })
  }, [filter])

  const column = [
    {
      title: "Mã đơn hàng",
      dataIndex: "export_code",
      align: "center",
      render: (text, record) => (
        <a
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenDetailModal(record)
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Khách hàng",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    {
      title: "Số lượng SIM",
      dataIndex: "sim_quantity",
      key: "sim_quantity",
      align: "center",
      render: (value, record) => (
        <a
          style={{ color: "#28a745", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenSimModal(record)
          }}
        >
          {value}
        </a>
      ),
    },
    {
      title: "Tổng tiền trước chiết khấu",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền sau chiết khấu",
      dataIndex: "total_discount",
      key: "total_discount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Lợi nhuận",
      dataIndex: "profit",
      key: "profit",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "created_at", // nhớ đúng key từ API (created_at, không phải create_at)
      key: "created_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
    {
      title: "Ngày duyệt xuất kho",
      dataIndex: "approved_export_at",
      key: "approved_export_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const handleOpenDetailModal = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }

  // mở modal seri SIM
  const handleOpenSimModal = record => {
    setSelectedRecord(record)
    setIsSimModalOpen(true)
  }

  const handleCloseModals = () => {
    setIsDetailModalOpen(false)
    setIsSimModalOpen(false)
    setSelectedRecord(null)
  }
  return (
    <div>
      <div style={{ display: "flex" }}>
        <FilterCustom
          setFilter={setFilter}
          setKeyword={setKeyword}
          // tabStatus={tabStatus}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng số SIM: {summary?.total_sim}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>Tổng tiền: {summary?.total_amount}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tổng tiền sau chiết khấu: {summary?.total_discount}</strong>
        </div>
        <div
          style={{ padding: "0 5px", color: "#90be3bff", minWidth: "150px" }}
        >
          <strong>Tổng lợi nhuận: {summary?.total_profit}</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={column}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {selectedRecord && (
        <ViewSaleDetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseModals}
          recordId={selectedRecord.ID}
        />
      )}
      {isSimModalOpen && (
        <ViewSimDetailModal
          visible={isSimModalOpen}
          onClose={handleCloseModals}
          id={selectedRecord?.ID}
          api={ReportsService.detailSimSale}
        />
      )}
    </div>
  )
}

export default ListSale
